module.exports = __webpack_public_path__ + "media/phase-4-complete.215a1979.mp4";